import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "underscore";

@Pipe({
  name: 'filter',
    pure:false
})
export class FilterPipe implements PipeTransform {

    transform(items: any[], element: any): any[] {
        if(!items) return [];
        if(!element) return items;
        let searchText = element.text.toLowerCase();

        if(element.by == null){
            return _.filter(items,function(item){
                return _.chain(item)
                    .values()
                    .find((k)=>{if(!_.isObject(k) && k.toLowerCase().includes(searchText)){
                        return true;
                    }else if(_.isObject(k)){
                        for(let key in k){
                           if(key.toLowerCase().includes(searchText) || k[key].toString().toLowerCase().includes(searchText)){
                               return true;
                           }
                        }
                    }
                    })
                    .value();
            })
        }else{
            return _.filter(items,function(item) {
                if(!_.isObject(item[element.by]) && item[element.by].toLowerCase().includes(searchText)){
                    return true;
                }else if(_.isObject(item[element.by])){
                    for(let key in item[element.by]){
                        if(key.toLowerCase().includes(searchText) || item[element.by][key].toString().toLowerCase().includes(searchText)){
                            return true;
                        }
                    }
                }
            })
        }
    }
}





// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/pipes/filter.pipe.ts